module.exports = __webpack_public_path__ + "headshot-john-jantsch.0c819c.png";